export const HOST_ENVS = {
  local: 'local',
  develop: 'development',
  preproduction: 'preproduction',
  production: 'production',
};
